import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Sun } from "lucide-react";
import { Container } from "./Primitives";
import { getTodaysMuhurat } from "../lib/api";

export function MuhuratRibbon() {
  const { data } = useQuery({
    queryKey: ["todays-muhurat"],
    queryFn: getTodaysMuhurat,
    staleTime: 10 * 60_000,
  });

  if (!data) return null;

  return (
    <div className="muhurat-ribbon" data-testid="muhurat-ribbon">
      <Container className="flex items-center justify-between gap-4">
        <div className="flex min-w-0 items-center gap-2.5">
          <Sun className="h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" />
          <p className="muhurat-ribbon__text truncate" data-testid="muhurat-window">
            {data.observed ? (
              <>
                <span className="muhurat-ribbon__label max-sm:hidden">Today's auspicious window</span>
                <span className="muhurat-ribbon__strong">Abhijit Muhurat</span>
                {" · "}
                <span className="num muhurat-ribbon__strong">
                  {data.window.start} – {data.window.end} IST
                </span>
              </>
            ) : (
              <span>Abhijit Muhurat is traditionally not observed on Wednesdays.</span>
            )}
          </p>
        </div>
        {data.next_festival && (
          <p className="muhurat-ribbon__text hidden truncate md:block" data-testid="muhurat-next-festival">
            Next: <span className="muhurat-ribbon__strong">{data.next_festival.name}</span>
            {" · "}
            <span className="num">{data.next_festival.date_label}</span>
          </p>
        )}
        <Link
          to="/tools/muhurat-calendar"
          className="muhurat-ribbon__link shrink-0"
          data-testid="muhurat-calendar-link"
        >
          Full calendar →
        </Link>
      </Container>
    </div>
  );
}
